import React, { useState, useEffect } from 'react';

const ScrollUp = () => {
    const [showScroll, setShowScroll] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 350) {
                setShowScroll(true);
            } else {
                setShowScroll(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <button
            className={`scrollup ${showScroll ? 'show-scroll' : ''}`}
            onClick={scrollToTop}
            aria-label="Scroll to top"
        >
            <i className="ri-arrow-up-s-line"></i>
        </button>
    );
};

export default ScrollUp;
